import { Box, Typography } from "@mui/material";
import { IPunctualityResponse } from "interfaces/IPunctuality";

interface GroupSummaryProps {
  group: IPunctualityResponse;
  isMobile?: boolean;
}

export const GroupSummary = ({ group, isMobile = false }: GroupSummaryProps) => {
  const content = (
    <>
      <Typography variant="body2">
        <b>Pontualidade:</b> {group.punctuality.toFixed(2)}%
      </Typography>
      <Typography variant="body2">
        <b>Total de Pedidos:</b> {group.totalOrders < 10 ? `0${group.totalOrders}` : group.totalOrders}
      </Typography>
      <Typography variant="body2">
        <b>Total de Atrasos:</b> {" "}
        {group.totalDelays < 10 ? `0${group.totalDelays}` : group.totalDelays}
      </Typography>
    </>
  );

  if (isMobile) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mb: 3,
          p: 2,
          bgcolor: 'background.paper',
          borderRadius: 1
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      mr={4}
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      gap={{ xs: 1, md: 4 }}
    >
      {content}
    </Box>
  );
};
